import cn from '@/lib/cs';
import React from 'react';

const CollectionsIcon = ({ className, ...props }: React.SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        aria-hidden
        className={cn('h-8 lg:h-12 pointer-events-none', className)}
        {...props}
    >
        <path
            className="transition-all"
            fill="currentColor"
            d="M5.6 22.7C4 21 3.8 18.1 3.3 16c-1.2-2.4-.9-5.4-2.7-7.6-1.4-5-.5-4.2 4-5.3C7 2.1 10.3 1 13 1c1.4 0 3.6 11.4 5.2 16.7-.5 2.1-3.4 2.2-5 3.1-2.6.5-5 2-7.6 2Zm8-.8h-.4c2.1-.9 5.3-1 5.8-3.7.5 4.3-2.6 3.5-5.5 3.7ZM19 17C18 12.1 17 7 15.1 2.3 20.6 1 17.5 14 19.1 17Zm-4.8 7c-1.2-1-2.8-.6-3.8-1.6 2 .3 8.6 0 3.8 1.5Zm5.4-10c0-3 .1-6-.5-8.8.8.8 2.4.7 2.6 1.8l-2 7Zm.3 2.5c0-1 .6-2 1-2.9 0-1.9 1.5-3.3 1.6-5 3.6 2.9-1.7 5.2-2.6 8Z"
        />
    </svg>
);

export default CollectionsIcon;
